// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1MVPc","buttons":"RemoveExpirationActionButtons_buttons__VuIp8"};